import { render, staticRenderFns } from "./ConfigurarReportes.vue?vue&type=template&id=24dfc02b&"
import script from "./ConfigurarReportes.vue?vue&type=script&lang=js&"
export * from "./ConfigurarReportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports